
const prod = {
  url: "https://monapplication.ddns.net/"
};
const dev = {
  url: "http://127.0.0.1:3000/"
};

export default process.env.NODE_ENV === 'development' ? dev : prod;